const CONFIG = {
	title: 'Zender Live Studio',
	targetsRoot: 'https://api.staging.zender.tv/v1/targets',
	channelsRoot: 'https://api.staging.zender.tv/v1/channels',
};

export default CONFIG;



// WEBPACK FOOTER //
// ./src/config/staging.js